export class UserModuleAnswerTask {
	private _id: string;
	private _label: string;
	private _dueDate: Date;
	private _userTaskId: string;

	constructor(id: string, label: string, dueDate: Date, userTaskId: string) {
		this._id = id;
		this._label = label;
		this._dueDate = dueDate;
		this._userTaskId = userTaskId;
	}

	public get id(): string {
		return this._id;
	}

	public get label(): string {
		return this._label;
	}

	public get dueDate(): Date {
		return this._dueDate;
	}

	public get userTaskId(): string {
		return this._userTaskId;
	}
}
